import * as R from 'ramda'

export const getIsFetchingCategoryList = R.path([
  'category',
  'processing',
  'getCategoryList'
])

export const getCategoryList = R.path(['category', 'categoryList'])

export const getIsFetchingCategoryDetail = R.path([
  'category',
  'processing',
  'getCategoryDetail'
])

export const getCategoryDetail = R.path(['category', 'categoryDetail'])

export const getIsCreateOrUpdatingCategory = R.path([
  'category',
  'processing',
  'createOrUpdatingCategory'
])
